import React, { useState } from 'react'
import TourNavigator from './TourNavigator/TourNavigator'
import TourHelper from './TourHelper'

export default function Gallery() {
  const [images, setImages] = useState([
    'https://cdn.pixabay.com/photo/2016/05/05/02/37/sunset-1373171_1280.jpg',
    'https://images.ctfassets.net/hrltx12pl8hq/a2hkMAaruSQ8haQZ4rBL9/8ff4a6f289b9ca3f4e6474f29793a74a/nature-image-for-website.jpg?fit=fill&w=600&h=400',
    'https://img.freepik.com/free-photo/painting-mountain-lake-with-mountain-background_188544-9126.jpg',
    'https://img.freepik.com/free-photo/abstract-autumn-beauty-multi-colored-leaf-vein-pattern-generated-by-ai_188544-9871.jpg',
    'https://buffer.com/library/content/images/size/w1200/2023/10/free-images.jpg',
    'https://th.bing.com/th/id/OIG4.LgUj9FIjzUbdTSMn0mRg',
    'https://deepai.org/static/images/cyberpunkdolphin.png',
    'https://image.shutterstock.com/image-photo/mountains-under-mist-morning-amazing-260nw-1725825019.jpg',
    'https://images.unsplash.com/photo-1645217925673-b36ba69814ec?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDR8fHxlbnwwfHx8fHw%3D&w=1000&q=80',
    'https://images.unsplash.com/photo-1701726761043-d0232a22c78b?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
  ])
  return (
    <div id='gallery' style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 30, padding: 30}}>
        {
            images.map((url, i) => {
                return <img key={i} src={url} id={`img-${i}`} style={{width: '100%', height: '100%', borderRadius: 10, aspectRatio: '1/1', objectFit: 'cover'}}/>
            })
        }
        <TourNavigator
            id='gallery'
            steps={[
                {
                    selector: `#img-0`,
                    data: {title: 'Image 1', description: 'Description 1'}
                },
                {
                    selector: `#img-2`,
                    data: {title: 'Image 1', description: 'Description 1'}
                },
                {
                    selector: `#img-3`,
                    data: {title: 'Image 1', description: 'Description 1'}
                },{
                    selector: `#img-5`,
                    data: {title: 'Image 1', description: 'Description 1'}
                },{
                    selector: `#img-6`,
                    data: {title: 'Image 1', description: 'Description 1'}
                },{
                    selector: `#img-8`,
                    data: {title: 'Image 1', description: 'Description 1'}
                },{
                    selector: `#img-9`,
                    data: {title: 'Image 1', description: 'Description 1'}
                }
            ]}
            helper={TourHelper}
            scrollingElement='#gallery'
            scrollIntoViewOptions={{behavior: 'smooth', block: 'nearest', inline: 'nearest'}}
        />
    </div>
  )
}
